const formatRelativeLocale = {
  lastWeek: "'आखिरी' eeee 'को' p 'बजे'",
  yesterday: "'कल' p 'बजे'",
  today: "'आज' p 'बजे'",
  tomorrow: "'कल' p 'बजे'",
  nextWeek: "eeee 'को' p 'बजे'",
  other: 'P',
};

export default function formatRelative(token, date, baseDate, options) {
  return formatRelativeLocale[token];
}
